<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      marker: { position: { lat: 28.7041, lng: 77.1025 } },
      locations: [],
      selectedLocation: null,
      infoBoxOpen: false,
    };
  },
  props: ["userId"],
  components: {},
  computed: {
    ...mapGetters("chargerManagement", ["getAllChargers"]),
  },
  mounted() {
    this.getAllChargersDetails();
  },
  watch: {},
  methods: {
    ...mapActions("chargerManagement", ["getAllChargersDetail"]),
    getAllChargersDetails() {
      this.getAllChargersDetail().then(() => {
        this.locations = this.getAllChargers;
        if (this.locations[0]) {
          this.marker.position.lat = parseFloat(this.locations[0].latitude);
          this.marker.position.lng = parseFloat(this.locations[0].longitude);
        }
      });
    },
    openInfoWindow(location) {
      this.selectedLocation = location;
      this.infoBoxOpen = true;
    },
    closeInfoWindow() {
      this.infoBoxOpen = false;
    },
  },
};
</script>
<template>
  <div class="row">
    <GmapMap
      :center="marker.position"
      :zoom="5"
      map-style-id="roadmap"
      style="width: 100%; height: 500px"
      ref="mapRef"
    >
      <GmapMarker
        :key="index"
        v-for="(location, index) in locations"
        :position="{
          lat: parseFloat(location.latitude),
          lng: parseFloat(location.longitude),
        }"
        :clickable="true"
        :draggable="false"
        :icon="
          location.status == '0'
            ? { url: require('@/assets/images/green-icon.png') }
            : location.status == '1'
            ? { url: require('@/assets/images/red-icon.png') }
            : { url: require('@/assets/images/orange-icon.png') }
        "
        @click="openInfoWindow(location)"
      />
      <gmap-info-window
        v-if="selectedLocation !== null"
        :position="{
          lat: parseFloat(selectedLocation.latitude),
          lng: parseFloat(selectedLocation.longitude),
        }"
        :opened="infoBoxOpen"
        @closeclick="closeInfoWindow()"
      >
        <div class="infoWindow">
          <h2 id="infoWindow-location">{{ selectedLocation.name }}</h2>
          <h6>
            {{ selectedLocation.address }}
          </h6>

          <h6>
            Charger Type - {{ selectedLocation.is_private == 1 ? "Private" : "Public" }}
          </h6>
          <!-- <button @click="closeInfoWindow()">Close</button> -->
        </div>
      </gmap-info-window>
    </GmapMap>
  </div>
</template>
